import { Analytics } from 'hooks/useAnalytics'

export const trackSubscriptionUpdate = (args: {
    spaceName: string
    spaceId: string
    duration: string
    type: 'enable' | 'disable'
    success: boolean
}) => {
    const { spaceName, spaceId, duration, success, type } = args
    Analytics.getInstance().track('update autopay', {
        type, //enable, disable
        spaceName,
        spaceId,
        duration, // monthly, weekly, annual
        success, // boolean (false if the action failed)
    })
}

export const trackRenewMembership = (args: {
    spaceName: string
    spaceId: string
    duration: string
    success: boolean
    location: 'reminder' | 'subscriptions' | 'town-page'
}) => {
    const { spaceName, spaceId, duration, success, location } = args
    Analytics.getInstance().track('renew membership', {
        location, // reminder, subscriptions
        spaceName,
        spaceId,
        duration, // monthly, weekly, annual
        success, // boolean (false if the action failed)
    })
}
